/**
 * Checks if value is a plain javascript object. returns true or false.
 * @param {anything} value - value to check
 */
const isPlainObject = (value) => typeof value === "object" && value !== null;

export default isPlainObject;
